import { SVGProps } from "react"

interface CalendarIconProps extends SVGProps<SVGSVGElement> {
  stroke?: string;
}

const CalendarIcon = ({ stroke = "#647188", ...props }: CalendarIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13.5} height={15} {...props}>
    <g
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      data-name="Component 6352 \u2013 2"
      transform="translate(.75 .75)"
    >
      <rect
        width={12}
        height={12}
        data-name="Rectangle 4214"
        rx={2}
        transform="translate(0 1.5)"
      />
      <path d="M9 0v3" data-name="Line 1252" />
      <path d="M3 0v3" data-name="Line 1253" />
      <path d="M0 6h12" data-name="Line 1254" />
      <path d="M3 9h1.5v1.5H3z" data-name="Rectangle 4215" />
    </g>
  </svg>
)
export default CalendarIcon
